import { motion } from "framer-motion";
import { Home, Sparkles, Crown } from "lucide-react";

export const About = () => (
  <section id="about" className="bg-background py-12 md:py-16">
    <div className="container">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.3em] text-gold">Our Mission</p>
          <h2 className="font-display text-5xl tracking-wide text-ink md:text-6xl">
            Reclaim Your<br />
            <span className="text-gradient-gold">Garage. Reclaim Your Space.</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
            At Garage Kings YEG, our mission is to help Edmonton homeowners reclaim their most
            valuable underutilized space: the garage. We believe a clear home leads to a clear
            mind, and we are dedicated to providing the most professional, reliable, and
            efficient property resets in the city.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
            As a locally owned and operated Edmonton business, we take pride in our community.
            We aren't just hauling junk; we are specialists in complete garage transformations.
            From massive property resets to targeted organization, our team is committed to
            eco-friendly disposal and high-standard service that treats your property with the
            respect it deserves. We work hard so you can finally park your car where it belongs.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-4">
            {["Edmonton Only", "Cash Paid On Spot", "Flat Rate Always"].map((s) => (
              <div key={s} className="rounded-lg border-2 border-gold/30 bg-card p-4 text-center">
                <div className="font-display text-base tracking-wide text-ink">{s}</div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative"
        >
          <div className="absolute -inset-4 rounded-2xl bg-gold/15 blur-2xl" />
          <div className="relative overflow-hidden rounded-2xl border-2 border-gold/30 bg-gradient-to-br from-navy via-ink to-navy p-6 shadow-elevated sm:p-10">
            <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-gold/15 ring-2 ring-gold/40">
              <Home className="h-12 w-12 text-gold" strokeWidth={1.5} />
            </div>
            <h3 className="mt-6 text-center font-display text-3xl tracking-wide text-white">
              Organization with a Crown
            </h3>
            <p className="mt-3 text-center text-white/70">
              From chaos to category — every project ends with a garage you'll show off.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3">
              <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 p-4">
                <Sparkles className="h-5 w-5 flex-none text-gold" />
                <span className="text-sm font-semibold text-white">Spotless finish</span>
              </div>
              <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 p-4">
                <Crown className="h-5 w-5 flex-none text-gold" />
                <span className="text-sm font-semibold text-white">Premium service</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
